import { observable } from "mobx";
import { Type } from "class-transformer";
import BankCodeType from "./bankCodeType";
import CounterpartyBankAccountResponse from "./counterpartyBankAccountResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidatePreviewCounterpartyBankResponse {
  @observable
  @Type(() => CounterpartyBankAccountResponse)
  bankAccount!: CounterpartyBankAccountResponse;

  /**
   * Counterparty name.
   */
  @observable
  name?: string;

  /**
   * Counterparty city address.
   */
  @observable
  cityAddress?: string;

  /**
   * Counterparty country ID.
   */
  @observable
  countryId?: string;

  @observable
  codeType?: BankCodeType;
}
